import { defineStore } from 'pinia'

export const useConfigStore = defineStore('configStore', {
  state: () => ({
    siteConfig: {
      home_banner: [{ url: '', link: '' }],
      recommend: [{ id: '', name: '', price: '', des: '', url_key: '', title: '', image: '' }],
      site_ico: '',
      site_logo: '',
    },
    channel_info: {},
    gtag: '',
    crmRefer: '',
    crmChannel: '',
    refer: '',
    utm_source: '',
    utm_medium: '',
    utm_campaign: '',
    utm_id: '',
    utm_term: '',
  }),
  actions: {
    updateConfig(config) {
      this.siteConfig = config
    },
    updateChannelInfo(channel) {
      this.channel_info = channel
    },
    updateGtag(gtag) {
      this.gtag = gtag
    },
    updateCrmRefer(refer) {
      this.crmRefer = refer
    },
    updateCrmChannel(channel) {
      this.crmChannel = channel
    },
    updateRefer(refer) {
      this.refer = refer
    },
    updateUtmSource(utm_source) {
      this.utm_source = utm_source
    },
    updateUtmMedium(utm_medium) {
      this.utm_medium = utm_medium
    },
    updateUtmCampaign(utm_campaign) {
      this.utm_campaign = utm_campaign
    },
    updateUtmId(utm_id) {
      this.utm_id = utm_id
    },
    updateUtmTerm(utm_term) {
      this.utm_term = utm_term
    },
  },
  persist: true,
})
